import { Icon, Panel, PanelType, Stack } from "office-ui-fabric-react";
import { useEffect, useState } from "react";
import { Redirect, useHistory } from "react-router";
import { loadFloorplansForLocation } from "../../../api/floorplans";
import { IFloorplan } from "../../../types/SiteLocation.types";

export interface IBookingFloorplanPanelProps {
    onDismiss: () => void;
    startDateStr: string;
    endDateStr: string;
    siteId: number;
    locationId: number;
}

export const BookingFloorplanPanel = (props: IBookingFloorplanPanelProps) => {
    const {startDateStr, endDateStr, siteId, locationId, onDismiss} = props;
    const history = useHistory();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ loading, setLoading ] = useState(true);
    const [ floorplans, setFloorplans ] = useState<IFloorplan[]|undefined>();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ error, setError ] = useState<string>();

    const _loadFloorplans = async () => {
        setLoading(true);
        const floorplansResponse = await loadFloorplansForLocation(locationId);
        if (floorplansResponse.ok) {
            setFloorplans(await floorplansResponse.json());
        } else {
            setError("Unable to load floorplans: " + floorplansResponse.statusText);
        }
        setLoading(false);
    };

    useEffect(() => {
        _loadFloorplans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (floorplans && floorplans.length === 1) {
        return (
            <Redirect to={`/menu/book/desk/${startDateStr}/${endDateStr}/${siteId}/${locationId}/${floorplans[0].Id}`} />
        );
    }

    return (
        <Panel type={PanelType.smallFixedFar} isOpen={true} headerText="Choose a floorplan" onDismiss={onDismiss}>
            <p>Choose an area in which to book a desk:</p>
            <Stack horizontalAlign="center" style={{marginTop:20}}>    
                { floorplans !== undefined && floorplans.map((floorplan) => (
                    <button style={{backgroundColor: "#005EB8", color: "white", borderRadius: 7, marginBottom: 10}} onClick={() => {
                        history.push(`/menu/book/desk/${startDateStr}/${endDateStr}/${siteId}/${locationId}/${floorplan.Id}`);
                    }}>
                        <Stack horizontal horizontalAlign="space-around" verticalAlign="center" style={{width: 150, height: 100}}>
                            <Icon iconName="Nav2DMapView" style={{fontSize: "1.2rem"}} />
                            <div>{floorplan.Name}</div>
                        </Stack>
                    </button>
                ))}
            </Stack>
        </Panel>
    );
}